import { render, staticRenderFns } from "./MarketUpdates.vue?vue&type=template&id=5c546f9e&scoped=true&"
import script from "./MarketUpdates.vue?vue&type=script&lang=ts&"
export * from "./MarketUpdates.vue?vue&type=script&lang=ts&"
import style0 from "./MarketUpdates.vue?vue&type=style&index=0&id=5c546f9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c546f9e",
  null
  
)

export default component.exports